export function noop() {}

export async function asyncNoop() {}
